module.exports = __webpack_public_path__ + "static/media/icon-email.1a51aede.svg";